<template>
  <div class="ag-input-text-wrapper">
    <div class="text-faded">Filter by:</div>
    <div class="checkboxes">
      <q-checkbox
        size="xs"
        :value="yesFilter"
        :false-value="''"
        label="Yes"
        true-value="yes"
        @input="toggleYesFilter"
      />

      <q-checkbox
        v-if="hasIntermediate"
        size="xs"
        title="I don't know"
        :value="intermediateFilter"
        :false-value="''"
        :label="intermediateProps.label"
        :true-value="intermediateProps.trueValue"
        @input="toggleIntermediateFilter"
      />

      <q-checkbox size="xs" :value="noFilter" :false-value="''" label="No" true-value="no" @input="toggleNoFilter" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data: function() {
    return {
      yesFilter: '',
      noFilter: '',
      intermediateFilter: '',
      filter: ''
    }
  },

  computed: {
    colId() {
      return this.params.column.colId
    },

    hasIntermediate() {
      return this.params.hasIntermediate
    },

    intermediateProps() {
      if (!this.hasIntermediate) return
      const props = this.params.intermediateProps || {}
      return {
        trueValue: props.trueValue || 'null',
        label: props.label || 'Idk'
      }
    }
  },

  methods: {
    toggleYesFilter(val) {
      this.noFilter = ''
      this.intermediateFilter = ''
      this.yesFilter = val
      this.valueChanged(val)
    },

    toggleNoFilter(val) {
      this.yesFilter = ''
      this.intermediateFilter = ''
      this.noFilter = val
      this.valueChanged(val)
    },

    toggleIntermediateFilter(val) {
      this.yesFilter = ''
      this.noFilter = ''
      this.intermediateFilter = val
      this.valueChanged(val)
    },

    valueChanged(val) {
      this.filter = val
      this.params.filterChanged(this.buildModel())
    },

    isFilterActive() {
      return !!this.filter
    },

    setModel(model) {
      this.filter = !model ? '' : model.filter ? model.filter : ''
    },

    getModel() {
      if (!this.filter) return null
      return {
        filterType: 'boolean',
        type: 'contains',
        filter: this.filter
      }
    },

    onParentModelChanged(parentModel) {
      this.filter = !parentModel ? '' : parentModel.filter ? parentModel.filter : ''
    },

    buildModel() {
      const filterModel = this.params.api.getFilterModel()
      if (!this.filter && filterModel.hasOwnProperty(this.colId)) {
        delete filterModel[this.colId]
      } else {
        filterModel[this.colId] = {
          filterType: 'boolean',
          type: 'equals',
          filter: this.filter
        }
      }

      return filterModel
    }
  }
})
</script>

<style lang="stylus" scoped>
.ag-input-text-wrapper {
    width 100%
    display grid
    height 100%
    align-items center
    justify-items center
}
</style>
